import React, { forwardRef, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { SvgSpriteType, spriteIndexObj, spriteSymbolUrl } from 'autogen/spriteData';
import { ShippingSupplier } from 'autogen/sharedEnums';

interface ISpriteDataValue {
    id: string;
    classList?: string;
}

function getSpriteData(iconType: SvgSpriteType): ISpriteDataValue {
    return spriteIndexObj[iconType];
}

export default function icon(iconName: SvgSpriteType, modifiers = ''): string {
    const { id, classList = '' } = getSpriteData(iconName);
    const path = `${spriteSymbolUrl}#${id}`;

    return `
        <svg class="icon ${classList} ${modifiers}">
            <use href="${path}"></use>
        </svg>
    `;
}

export interface ISvgSprite extends HTMLAttributes<HTMLOrSVGElement> {
    sprite: SvgSpriteType;
    fill?: string;
}

const SvgElement = styled.svg``;

export const SvgSprite = forwardRef((props: ISvgSprite, ref: any): JSX.Element => {
    const { sprite, fill, className = '', ...rest } = props;

    if (!sprite) throw new Error(`Invalid sprite property of ${sprite || 'undefined'} was provided to SVG Sprite`);

    const { id, classList = '' } = getSpriteData(sprite) || {};
    const path = `${spriteSymbolUrl}#${id}`;

    return (
        <SvgElement className={`icon ${classList} ${className}`} {...rest} ref={ref}>
            <use fill={fill} href={path} />
        </SvgElement>
    );
});

export function getSupplierSVG(supplierEnum: ShippingSupplier): SvgSpriteType | false {
    switch (supplierEnum) {
        case 'Matas':
            return 'LogoMatas';
        case 'PostNord':
            return 'DeliveryPostNord';
        case 'GLS':
            return 'DeliveryGls';
        case 'DAO':
            return 'LogoDao';
        case 'DropShip':
            return false;
        case 'Digital':
            return false;
        case 'Burd':
            return 'LogoBurd';
        case 'Instabox':
            return 'LogoInstabox';
        case 'Bring':
            return 'LogoBring';
        case 'HeltHjem':
            return 'LogoHelthjem';
        default:
            return false;
    }
}
